export const paths = {
    index: '/',
    home: '/home',
    myVideos: '/my-videos',
    playbookDetails: '/playbooks/:playbookId',
    editPlaybook: '/playbooks/:playbookId/edit',
    playlistDetails: '/playbooks/playlist/:playbookId',
    editPlaylist: '/playbooks/playlist/:playbookId/edit',
    searchPlaylist: '/search/playlist/:playbookId',
    searchPlaybook: '/search/playbook/:playbookId',
    editQuickGuidde: '/workflows/:playbookId/edit',
    integrations: '/integrations',
    guiddeInside: '/integrations/guidde-inside',
    applications: '/integrations/applications',
    organizations: '/organizations',
    profile: '/profile',
    notifications: '/notifications',
    login: '/login',
    signup: '/signup',
    join: '/join/:orgId',
    guest: '/guest',
    emailLink: '/emailLink',
    joinSpace: '/join-space/:spaceId/:invitationId',
    playbookRequests: '/playbookRequests',
    playbookRequestDetails: '/playbookRequests/:requestId',
    appsManagement: '/apps-management',
    backoffice: '/backoffice',
    applicationLibrary: '/applications/library/:appId',
    invite: '/invite',
    accountSettings: '/account-settings',
    organizationSettings: '/account-settings/:orgId',
    slackAuth: '/slack-auth',
    insights: '/insights',
    insightsCustomers: '/insights/customers',
    insightsTeam: '/insights/teams',
    onboarding: '/onboarding',
    spaces: '/spaces',
    spaceLibrary: '/spaces/library/:spaceId',
    spaceLibraryFolder: '/spaces/library/:spaceId/:folderId',
    spaceDetails: '/spaces/:spaceId',
    activity: '/activity',
    publicPlaybook: '/share/playbooks/:playbookId',
    publicPlaylist: '/share/playlists/:playbookId',
    ssoLogin: '/ssologin',
    welcome: '/welcome',
    brandKit: '/brand-kit',
    domainRedirect: '/domain-redirect'
} as const
